export const SITE = {
  brand: "InflatableTx",
  domain: "https://inflatabletx.com",
  phone: "(682) 202-5624",
  email: "info@inflatabletx.com",
  address: {
    street: "100 E Vaughn",
    city: "Cleburne",
    region: "TX",
    postalCode: "76031",
    country: "US",
  },
  socials: {
    facebook: "https://www.facebook.com/inflatabletx",
  }
};
